module.exports = __webpack_public_path__ + "img/code-sandbox.6ab73335.svg";